import {
  AdministrationRepository,
  ListIncidentsParams,
} from '@lib/api/repository/administration/administration.repository';
import {
  AdministrationOverview,
  OperationalIncident,
  OperationalIncidentMetrics,
  PlatformHealthReport,
} from '@lib/types';

import { Requester } from '../clients';

export default class AdministrationAPI implements AdministrationRepository {
  async overview(signal?: AbortSignal) {
    return (
      await Requester.get<AdministrationOverview>(
        '/marketplace/admin/overview', { signal },
      )
    ).data;
  }

  async platformHealth(signal?: AbortSignal) {
    return (
      await Requester.get<PlatformHealthReport>(
        '/marketplace/admin/health', { signal },
      )
    ).data;
  }

  async listIncidents(params?: ListIncidentsParams, signal?: AbortSignal) {
    return (
      await Requester.get<{
        items: OperationalIncident[];
        total: number;
        page: number;
        limit: number;
      }>('/marketplace/admin/incidents', {signal,  params })
    ).data;
  }

  async getIncident(codeOrId: string, signal?: AbortSignal) {
    return (
      await Requester.get<OperationalIncident>(
        `/marketplace/admin/incidents/${codeOrId}`, { signal },
      )
    ).data;
  }

  async updateIncidentStatus(id: string, status: string, notes?: string) {
    return (
      await Requester.patch<OperationalIncident>(
        `/marketplace/admin/incidents/${id}/status`,
        { body: { status, notes } },
      )
    ).data;
  }

  async getIncidentMetrics(signal?: AbortSignal) {
    return (
      await Requester.get<OperationalIncidentMetrics>(
        '/marketplace/admin/incidents/metrics', { signal },
      )
    ).data;
  }
}

